<template>
    <router-link :to="link" class="card card--event">
        <div class="grid align-center">
            <div class="col-lg-3 col-md-12">
                <picture class="card__thumbnail">
                    <img :src="currEvent.backgroundImage" alt="Event Image" class="card__image">
                </picture>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="card__header" v-if="currEvent.eventName">
                    <h3 class="card__title">{{ currEvent.eventName }}</h3>
                </div>
                <div class="card__body" v-if="currEvent.start">
                    <p>{{ currEvent.start.displayDate }}</p>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'EventCard',
        props: {
            currEvent: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                flags: true,
            }
        },
        computed: {
            link() {
                return { name: 'view-event', params: { event_id: this.currEvent.id }};
            }
        }
    }
</script>

<style scoped lang="scss">
    .card--event {
        &, * {
            color: #000000;
        }

        .card__thumbnail {
            width: 100%;
            height: auto;
            border-radius: 1rem;
            overflow: hidden;
            display: block;
            line-height: 0;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                max-width: initial;
            }
        }
    }
</style>
